import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logos/Main/Myceleblogo.png'
import _imports_1 from '../../assets/images/white-logo.svg'
import _imports_2 from '../../assets/images/search.png'
import _imports_3 from '../../assets/images/icon-right-white.png'


const _withScopeId = n => (_pushScopeId("data-v-3e815a3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mw-1740" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "main-logo",
  alt: "white-logo"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "white-logo d-none",
  alt: "white-logo"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-toggler",
  "data-bs-toggle": "offcanvas",
  href: "#navbarOffcanvas",
  role: "button",
  "aria-controls": "navbarOffcanvas"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "burger-menu" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "top-bar" }),
    /*#__PURE__*/_createElementVNode("span", { class: "middle-bar" }),
    /*#__PURE__*/_createElementVNode("span", { class: "bottom-bar" })
  ])
], -1))
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_6 = { class: "navbar-nav me-auto" }
const _hoisted_7 = { class: "nav-item dropdown" }
const _hoisted_8 = { class: "nav-item dropdown" }
const _hoisted_9 = { class: "nav-item dropdown" }
const _hoisted_10 = { class: "nav-item dropdown" }
const _hoisted_11 = { class: "nav-item dropdown" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  href: "javascript:void(0)",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " OUR WORK ", -1))
const _hoisted_13 = { class: "dropdown-menu" }
const _hoisted_14 = { class: "nav-item dropdown" }
const _hoisted_15 = { class: "others-options" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<li class=\"d-none d-xl-block\" data-v-3e815a3c><form class=\"src-form position-relative z-1\" data-v-3e815a3c><input type=\"text\" class=\"form-control\" placeholder=\"Search here....\" data-v-3e815a3c><button type=\"submit\" class=\"src-btn bg-transparent p-0 border-0 position-absolute top-50 end-0 translate-middle-y\" data-v-3e815a3c><img src=\"" + _imports_2 + "\" alt=\"search\" data-v-3e815a3c></button></form></li>", 1)
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "right-chevron"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(['navbar navbar-expand-lg bg-white ptb-21', { sticky: _ctx.isSticky }]),
    id: "navbar"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "navbar-brand me-95",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/social-media-ad-agency"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" HOME ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/services"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" SERVICES ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/about-us"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" SERVICES ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/Client"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" OUR CLIENTS ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("ul", _hoisted_13, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  class: "dropdown-item",
                  to: "/success-stories"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" SUCCESS STORIES ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  class: "dropdown-item",
                  to: "/success-story-details"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" SUCCESS STORY DETAILS ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_14, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/contact-us"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" CONTACT ")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("ul", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/contact-us",
              class: "default-btn btn-two"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" LET’S TALK "),
                _hoisted_18
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ], 2))
}